import type { CadenceTask } from "../../api/cadence.ts";
import { periodLabel, statusLabel } from "../CadenceCalendar.helpers.ts";

type LeadHistoryPanelProps = {
  leadName: string;
  tasks: CadenceTask[];
  loading: boolean;
  onClose: () => void;
};

export function LeadHistoryPanel({ leadName, tasks, loading, onClose }: LeadHistoryPanelProps) {
  return (
    <section className="cadence-history" aria-label="Historico de cadencia">
      <div className="cadence-history-head">
        <div>
          <span className="cadence-eyebrow">Historico</span>
          <h3>{leadName || "Lead"}</h3>
        </div>
        <button type="button" onClick={onClose}>Fechar</button>
      </div>
      {loading ? <div className="cadence-empty">Carregando historico...</div> : null}
      {!loading && !tasks.length ? <div className="cadence-empty">Sem historico de cadencia para este lead.</div> : null}
      {!loading && tasks.length ? (
        <div className="cadence-history-list">
          {tasks.map((task) => (
            <article key={task.id} className={`cadence-history-item status-${task.status}`}>
              <strong>{task.scheduledDate}</strong>
              <span>{periodLabel(task.scheduledPeriod)} - {statusLabel(task.status)}</span>
              {task.note ? <p>{task.note}</p> : null}
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
}
